import type RouterService from "@ember/routing/router-service";
import type Transition from "@ember/routing/transition";
import Service, { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import type SemeiaSessionService from "parog-web/services/session";

export default class TermsOfUseService extends Service {
  @tracked transition?: Transition = undefined;

  @service declare router: RouterService;
  @service declare session: SemeiaSessionService;

  /**
   * The current version of Terms of Use that users (patient or medics) must have accepted, to be granted the app access
   */
  get currentVersion() {
    return 2.0;
  }

  /**
   * The limit date the user can indicate that he refuses the latest terms of use.
   */
  get limitDate() {
    return "08/11/2020";
  }

  redirectToAcceptTermsOfUseIfNeeded(
    acceptedTermsOfUseVersion: number,
    transition: Transition
  ) {
    if (acceptedTermsOfUseVersion !== this.currentVersion) {
      // Store the transition only for useful routes, different than terms-of-use
      if (!transition.to?.name.includes("terms-of-use")) {
        this.transition = transition;
      }

      this.router.transitionTo("terms-of-use");
    }
  }

  continueNavigationAfterAcceptingTermsOfUse() {
    if (this.transition) {
      this.transition.retry();
      this.transition = undefined;
    } else {
      this.router.transitionTo("/");
    }
  }
}
